import React, { useEffect, useState } from "react";
import { supportedPreviewFormats } from "./helpers.js";

const useCreateThumbPreview = (file, preview) => {
  const [thumbPreview, setThumbPreview] = useState(null);
  // resizing original image to 450px max width and height for thumbPreview
  useEffect(() => {
    // get image blob from preview resize it to 450px max width and height and set it as thumbPreview state and after delete img from memory
    if (preview && supportedPreviewFormats.includes(file.type)) {
      if (file.type.includes("image")) {
        const img = new Image();
        img.src = preview;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const MAX_WIDTH = 450;
          const MAX_HEIGHT = 450;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          setThumbPreview(canvas.toDataURL("image/jpeg"));
        };
        // free memory
        img.remove();
      }
      if (file.type.includes("video")) {
        const video = document.createElement("video");
        video.src = preview;
        video.addEventListener("loadedmetadata", () => {
          video.currentTime = 5; // desiredTime is the time in seconds at which you want to capture the frame
        });

        video.addEventListener("timeupdate", () => {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
          const imageData = canvas.toDataURL(); // imageData contains the screenshot in base64 format
          setThumbPreview(imageData);
        });

        // free memory
        video.remove();
      }
    }
  }, [preview]);

  return thumbPreview;
};

export default useCreateThumbPreview;
